import React, { useEffect } from 'react';
import logo from '../../../assets/logos/text-logo-white.svg';
import Footer from '../../common/Footer/Footer';
import styles from './LegalLayout.module.scss';

const LegalLayout = ({ children, title }) => {
    useEffect(() => {
        document.body.style.background = "#0f0f0f";
        document.title = `${title} | STBL OHM`;
    }, [title]);

    return (
        <div className={styles.legalLayout}>
            <header className={styles.header}>
                <img src={logo} alt="STBL Logo" />
            </header>
            <main className={styles.contentWrapper}>
                <h1>{title}</h1>
                <div className={styles.placeholderContent}>
                    {children}
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default LegalLayout;
